import { resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-registration.svg'
import _imports_1 from '@/assets/img/logo_short.png'
import _imports_2 from '@/assets/img/logo2.svg'
import _imports_3 from '@/assets/img/logo_full.png'
import _imports_4 from '@/assets/img/graphic/welcome-back.png'


const _withScopeId = n => (_pushScopeId("data-v-c82b15be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login__body" }
const _hoisted_2 = {
  key: 0,
  class: "login__logo",
  src: _imports_0,
  alt: "logo"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "login__logo",
  src: _imports_1,
  alt: "logo"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "login__title" }, "Login", -1))
const _hoisted_5 = {
  key: 1,
  class: "desktop--wrapper"
}
const _hoisted_6 = { class: "header--desktop" }
const _hoisted_7 = { class: "desktop--container" }
const _hoisted_8 = {
  key: 0,
  class: "logo--desktop",
  src: _imports_2,
  alt: ""
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo--desktop",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "desktop--container--sm" }
const _hoisted_11 = { class: "desktop--content" }
const _hoisted_12 = { class: "desktop--content--body" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title--page" }, "Login", -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Forgot password? ")
const _hoisted_16 = { class: "desktop--content--footer" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "or-text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "or")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text--create-account" }, "Do you have an account already?", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Create Account ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--img--wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "banner"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_login_register = _resolveComponent("app-login-register")!
  const _component_app_alert = _resolveComponent("app-alert")!
  const _component_Form = _resolveComponent("Form")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createBlock(_component_el_container, {
        key: 0,
        direction: "vertical",
        class: "login__wrapper"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_header, null, {
            "top-left": _withCtx(() => []),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            false
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : _createCommentVNode("", true),
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_Form, {
              as: "el-form",
              "validation-schema": _ctx.schema,
              onSubmit: _ctx.startSubmit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_input, {
                  ref: "inputEmail",
                  name: "email",
                  inputmode: "email",
                  autocomplete: "email",
                  placeholder: _ctx.$localize('login.email.example'),
                  "prop-error": _ctx.emailError,
                  onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                  onPaste: _ctx.removeEventSpaces,
                  onDrop: _ctx.removeEventSpaces,
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errorKey = '')),
                  onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.focusNextInput('passInput')), ["enter"]))
                }, null, 8, ["placeholder", "prop-error", "onPaste", "onDrop"]),
                _createVNode(_component_app_input, {
                  id: "passInput",
                  ref: "pass",
                  name: "password",
                  autocomplete: "current-password",
                  placeholder: _ctx.$localize('login.your.password'),
                  "prop-error": _ctx.passwordRequired,
                  "show-password": "",
                  clearable: "",
                  "control-class": "mb-48",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorKey = ''))
                }, null, 8, ["placeholder", "prop-error"]),
                _createVNode(_component_app_button, {
                  type: "primary",
                  "native-type": "submit",
                  class: "w-100 el-button-lg",
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('login.button')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_app_login_register, { class: "mb-20" }),
                (_ctx.errorKey.length)
                  ? (_openBlock(), _createBlock(_component_app_alert, {
                      key: 0,
                      title: _ctx.$localize(_ctx.errorKey),
                      closable: false,
                      type: "error"
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["validation-schema", "onSubmit"]),
            (_ctx.dataRequest)
              ? (_openBlock(), _createBlock(_component_app_loader, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            false
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : _createCommentVNode("", true),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Form, {
              as: "el-form",
              "validation-schema": _ctx.schema,
              onSubmit: _ctx.startSubmit
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_app_input, {
                    ref: "inputEmail",
                    name: "email",
                    placeholder: _ctx.$localize('login.email.example'),
                    "prop-error": _ctx.emailError,
                    onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                    onPaste: _ctx.removeEventSpaces,
                    onDrop: _ctx.removeEventSpaces,
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.errorKey = '')),
                    onKeypress: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.focusNextInput('passInput')), ["enter"]))
                  }, null, 8, ["placeholder", "prop-error", "onPaste", "onDrop"]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_app_input, {
                      id: "passInput",
                      ref: "pass",
                      name: "password",
                      placeholder: _ctx.$localize('login.your.password'),
                      "prop-error": _ctx.passwordRequired,
                      "show-password": "",
                      clearable: "",
                      "control-class": "mb-48",
                      onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.errorKey = ''))
                    }, null, 8, ["placeholder", "prop-error"]),
                    _createVNode(_component_router_link, {
                      to: "/password-reset",
                      class: "forgot"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.errorKey.length)
                    ? (_openBlock(), _createBlock(_component_app_alert, {
                        key: 0,
                        title: _ctx.errorKey,
                        closable: false,
                        type: "error"
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "large",
                    class: "el-button w-100 el-button-lg",
                    "native-type": "submit",
                    round: "",
                    "control-class": "mb-48",
                    loading: _ctx.dataRequest
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  _hoisted_18,
                  _hoisted_19,
                  _createVNode(_component_router_link, {
                    to: "/registration/step-1",
                    class: "link--create-account"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary-outline",
                        size: "large",
                        class: "w-100",
                        "native-type": "submit",
                        round: "",
                        "control-class": "mb-48"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["validation-schema", "onSubmit"])
          ])
        ]),
        _hoisted_21
      ]))
}